import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { FlaskConical } from 'lucide-react';
import KillSwitchBar from '../../components/strategy-lab/KillSwitchBar';

const TABS: { path: string; label: string }[] = [
  { path: 'watchlists', label: 'Watchlists' },
  { path: 'scanners', label: 'Scanners' },
  { path: 'strategies', label: 'Strategies' },
  { path: 'deployments', label: 'Deployments' },
];

function tabClassName(isActive: boolean): string {
  return [
    'inline-flex items-center rounded-md px-3 py-1.5 text-sm font-medium transition-colors border',
    isActive
      ? 'bg-primary text-primary-foreground border-primary shadow-sm'
      : 'bg-card text-muted-foreground border-border hover:text-foreground hover:bg-muted/50',
  ].join(' ');
}

/**
 * Strategy Lab shell — the isolated scanner + autonomous day-trading workspace.
 * Tabs: Watchlists | Scanners | Strategies | Deployments, each a nested route.
 */
export default function StrategyLabLayout() {
  return (
    <div className="space-y-6 min-w-0 max-w-7xl mx-auto pb-10">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <FlaskConical className="w-7 h-7 text-primary" />
          Strategy Lab
        </h1>
        <p className="text-sm text-muted-foreground mt-1 max-w-3xl">
          Curate watchlists, build scanners from combinable day-trading triggers, craft
          custom strategies, and deploy each with a daily dollar budget. The Lab trades an
          isolated paper account — separate from the main autonomous fleet.
        </p>
      </div>

      <KillSwitchBar />

      <nav className="flex flex-wrap gap-2 border-b border-border pb-3" aria-label="Strategy Lab sections">
        {TABS.map((t) => (
          <NavLink key={t.path} to={t.path} className={({ isActive }) => tabClassName(isActive)}>
            {t.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
